import { FC } from 'react'
import shallow from 'zustand/shallow'
import { useAuth } from '../../../context/auth-context'
import { PyramidType } from '../../../types'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { CompanySettingsPyramidsRow } from './CompanySettingsPyramidsRow'
import { useCompanySettingsPyramids } from '../../../graphql/companySettings/useCompanySettingsPyramids'
import BackgroundBox from '../../../components/custom_components/BackgroundBox'
import '../index.less'
import { useHRSettingsStore } from '../hrSettings/HRSettingsStore'

export const CompanySettingsPyramidsTab: FC = () => {
  const { user } = useAuth()
  const [selected] = useHRSettingsStore((state) => [state.selected], shallow)

  const companyId = selected.companyId
  const country = selected.country
  const canEdit = !!user.roles && user.roles.filter((role) => role.toString() === `HR_ADMIN_${selected.country}`).length > 0

  const { data, error, loading } = useCompanySettingsPyramids(companyId, country)

  if (loading || error || !data) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data} error={error} showSpinner />
  } else {
    const ageReferencePyramid = data.ageReferencePyramid
    const hasAgeReferencePyramid =
      ageReferencePyramid && ageReferencePyramid.referencePyramidDetails && ageReferencePyramid.referencePyramidDetails.length > 0
    const levelReferencePyramid = data.levelReferencePyramid
    const hasLevelReferencePyramid =
      data.levelReferencePyramid &&
      data.levelReferencePyramid.referencePyramidDetails &&
      data.levelReferencePyramid.referencePyramidDetails.length > 0
    const isAgePyramidVisible: boolean = data.isAgePyramidVisible

    return (
      <BackgroundBox r color="boxshadow" noPadding className="per-companySettings--pyramids-content-height">
        <CompanySettingsPyramidsRow
          referenceTableData={
            levelReferencePyramid && levelReferencePyramid.referencePyramidDetails ? levelReferencePyramid.referencePyramidDetails : []
          }
          type={PyramidType.Level}
          companyId={companyId}
          country={country}
          referencePyramidId={levelReferencePyramid && levelReferencePyramid.id}
          predefinedScenario={data.levelReferencePyramidTemplate ? data.levelReferencePyramidTemplate : undefined}
          canEdit={canEdit}
          empty={!hasLevelReferencePyramid}
          margin
          employeeLevels={[...data.employeeLevels].sort((a, b) => a.displayOrder - b.displayOrder).map((e) => e.level)}
        />
        {isAgePyramidVisible && (
          <CompanySettingsPyramidsRow
            referenceTableData={
              ageReferencePyramid && ageReferencePyramid.referencePyramidDetails ? ageReferencePyramid.referencePyramidDetails : []
            }
            type={PyramidType.Age}
            companyId={companyId}
            country={country}
            referencePyramidId={ageReferencePyramid && ageReferencePyramid.id}
            predefinedScenario={data.ageReferencePyramidTemplate ? data.ageReferencePyramidTemplate : undefined}
            empty={!hasAgeReferencePyramid}
            canEdit={canEdit}
            employeeLevels={[...data.employeeLevels].sort((a, b) => a.displayOrder - b.displayOrder).map((e) => e.level)}
          />
        )}
      </BackgroundBox>
    )
  }
}
